<template>
  <v-form @keyup.native.enter="tryLogIn" ref="form" class="align-self-center">
    <h3 class="display-1 py-8 font-weight-bold">{{ $t('login') }}</h3>
    <v-text-field
      name="email"
      type="text"
      v-model="email"
      :rules="emailRules"
      :error="error.name"
      :label="$t('email')"
      @input="error.name = false"
      :error-messages="error.name ? this.$t('userNotExist') : null"
      outlined
    ></v-text-field>
    <v-text-field
      type="password"
      v-model="password"
      :label="$t('password')"
      :error="error.password"
      :error-messages="error.password ? this.$t('alertInvalidPassword') : null"
      @input="error.password = false"
      outlined
    ></v-text-field>
    <p v-if="error.general" class="text--accent-4 red--text text-center">{{ generalErrorText }}</p>
    <p class="caption py-2" align="center" v-if="errorStatus">
      <router-link
        :to="{name: 'ForgotPassword', params: {defaultEmail: this.email}}"
      >{{ $t('forgotPasswordLogin') }}</router-link>
    </p>
    <v-btn
      color="primary"
      depressed
      :disabled="!allValid"
      :loading="isLoading"
      rounded
      large
      block
      @click="logIn"
    >{{ $t('loginAction') }}</v-btn>
    <p class="caption pt-6" align="center">
      {{ $t('noAccount') }}
      <!-- eslint-disable-next-line max-len -->
      <router-link :to="{ name: 'SignUp', params: {defaultEmail: this.email}}">{{ $t('create') }}</router-link>
    </p>
    <p class="caption py-0" align="center">
      {{ $t('forgotPasswordQuestion') }}
      <router-link
        :to="{ name: 'ForgotPassword', params: {defaultEmail: this.email}}"
      >{{ $t('refresh') }}</router-link>
    </p>
  </v-form>
</template>

<script>
export default {
  name: 'LoginForm',
  data() {
    return {
      email: this.$route.params.defaultEmail,
      emailRules: [
        // eslint-disable-next-line no-confusing-arrow
        v =>
          // eslint-disable-next-line implicit-arrow-linebreak
          v ? this.validEmail() : this.inValidEmail(this.$t('emailRequired')),
        // eslint-disable-next-line no-confusing-arrow
        v =>
          // eslint-disable-next-line implicit-arrow-linebreak
          /.+@.+\..+/.test(v)
            ? this.validEmail()
            : this.inValidEmail(this.$t('emailValid')),
      ],
      mailOK: false,
      password: '',
      error: {
        name: false,
        password: false,
        general: false,
      },
      isLoading: false,
    };
  },
  computed: {
    allValid() {
      return this.mailOK && this.password.length;
    },

    errorStatus() {
      return this.error.name || this.error.password;
    },

    generalErrorText() {
      return this.$t('error');
    },
  },
  methods: {
    tryLogIn() {
      // eslint-disable-next-line no-unused-expressions
      this.allValid && this.logIn();
    },
    logIn() {
      this.isLoading = true;
      // eslint-disable-next-line no-return-assign
      Object.keys(this.error).forEach(v => (this.error[v] = false));
      this.$store
        .dispatch('logIn', {
          email: this.normalize(this.email),
          password: this.password,
        })
        .then(() => {
          this.$router.push('/home');
          this.$store.dispatch('logEvent', {
            name: 'user_logged_in',
          });
        })
        .catch(error => {
          this.isLoading = false;
          this.errorHandler(error);
        })
        .finally(() => {
        });
    },
    validEmail() {
      this.mailOK = true;
      return true;
    },
    normalize(str) {
      return str.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    },

    inValidEmail(string) {
      this.mailOK = false;
      return string;
    },

    errorHandler(error) {
      if (error.code === 'auth/user-not-found') {
        this.error.name = true;
      } else if (error.code === 'auth/wrong-password') {
        this.error.password = true;
      } else {
        this.error.general = true;
      }
    },
  },
};
</script>

<style scoped>
</style>
